import { configWithoutToken } from "./config";

export interface ISlider {
  id: string;
  imageUrl: string;
  title?: string;
  description?: string;
  linkUrl?: string;
  isEnabled: boolean;
  displayOrder: number;
  createdAt: string;
}

export const getActiveSliders = () => {
  return configWithoutToken.get<ISlider[]>("Slider/active");
};
